<template>
    <div v-if="title || lead" class="a-slice-header" :class="`is-${theme}`">
        <a-dangerous-html
            v-if="title"
            class="a-slice-header__title"
            :content="title"
            :tag="titleTag"
        />
        <a-dangerous-html
            v-if="lead"
            class="a-slice-header__lead"
            :content="lead"
            :tag="'p'"
        />
        <a-dangerous-html
            v-if="bodyText"
            class="a-slice-header__body-text"
            :content="bodyText"
            :tag="'p'"
        />
        <slot />
    </div>
</template>

<script>
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';

export default {
    name: 'ASliceHeader',

    components: {
        ADangerousHtml,
    },

    props: {
        theme: {
            type: String,
            default: 'light',
        },

        title: {
            type: String,
            default: '',
        },

        lead: {
            type: String,
            default: '',
        },

        bodyText: {
            type: String,
            default: '',
        },

        titleTag: {
            type: String,
            default: 'h2',
        },
    },
};
</script>

<style lang="postcss">
.a-slice-header {
    margin-bottom: 40px;

    @media (--viewport-desktop) {
        width: calc(((100% - 32px) / 3) * 2 + 16px);
    }

    &__title {
        @mixin display-accent;
        color: var(--av-nav-primary);
        margin-bottom: 24px;
        &:only-child {
            margin-bottom: 0;
        }
    }


    &__lead {
        @mixin title;
        color: var(--av-nav-primary);
    }

    &__body-text {
        @mixin paragraph;
        margin-top: 24px;
    }
}

h1.a-slice-header__title,
h2.a-slice-header__title {
    @media (--viewport-mobile-wide) {
        @mixin hero-accent;
    }
}

.is-dark {
    .a-slice-header__title,
    .a-slice-header__lead,
    .a-slice-header__body-text {
        color: var(--av-inversed-primary);
    }
}
</style>
